const {Component} = require("react");
const router = require("app/services/router");
const axios = require("axios");
const logger = require("app/services/logger");
const Modal = require("app/components/modals/Modal");
const env = require("app/services/env");
const Trans = require('app/components/trans/Trans')

class Widget extends Component {

	constructor(props) {
		super(props);

		this.state = {
			response: null,
			static: false,
			tomorrow: false,
          funeral: router.currentUrl.search(translate('begravelse')) >= 0 ? 1 : 0,
		};
	}

	static get defaultProps() {
	    return {
	        group: false,
		};
	}

	get classNames() {
		return [
			"cover-delivery-timechecker",
			this.props.group ? "in-group-header" : null,
		].filter(e=>e).join(' ');
	}

	submit = (day = 0) => {
		let value = this.input.value;

		if (!value) return;

		axios
			.post(router.route("api.deliveryTime.check", {zipcode: value, addDays: day, funeral: this.state.funeral}))
			.then(response => {
				this.setState({tomorrow: false, static: false, response: response.data});
				this.modal.open();
			})
			.catch(error => {
				logger.error(error);
			});
	}

	_handleTodayClick = () => {
		this.submit(0);
	}

	_handleTodayClickFuneral = () => {
		this.submit(0, 1);
	}

	_handleTomorrowClickFuneral = () => {
        this.submit(1, 1);
	}

	_handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			this.submit();
		}
	}

	_showStatic = (tomorrow) => {
		this.setState({
            tomorrow: !!tomorrow,
			static: true,
			response: null,
		}, () => {
			this.modal.open();
		})
	}

	renderTomorrowFuneral() {
		return (
			<div className="response">
                <span className="message">
                    <Trans> Din levering kan nå ud såfremt du bestiller før kl. 16.00<br/><br/>
                      Hvis leveringen skal ske en Mandag, skal du bestille senest Lørdag før kl. 12.00 </Trans>
                </span>
				{this.renderExtra()}
			</div>
		);
	}

	renderTodayFuneral() {
		return (
			<div className="response">
                <span className="message">
					<Trans> Leveringer til begravelser kan vi kun garantere hvis vi får ordren inden kl. 16.00 dagen forinden.<br/><br/>
                      Ved begravelser til om Mandag skal vi dog have ordren senest Lørdag kl. 12.00 </Trans>
				</span>

				<span className="message">
                    <br/><br/>
                  <b> <Trans> Husk at du kan prøve dit held: </Trans> </b><br/>
                    <Trans> Hvis du ønsker at få en bårebuket ud, kan vi i mange tilfælde stadig nå det efter deadline. Vi kan dog ikke garantere leveringen.
                      Hvis vi ikke kan levere, vil du blive kontatet af vores kundeservice, og der kan aftales en kondolance buket eller pengene retur. </Trans>
                </span>

				{this.renderExtra()}
			</div>
		);
	}

	renderExtra() {

      let salesTermsUrl = router.route('page.show', {pagePath: env.get('checkout.special_page_slugs.sales_terms', '')});

      return (
			<span className="message">
                <br/><br/>
              <i><Trans>*forudsat at ordren opfylder <a href={salesTermsUrl}>salgs- og leveringsbetingelserne</a></Trans></i>
            </span>
		);
	}

	renderStaticResponse() {
		if (!this.state.static) return null;

		return this.state.tomorrow ?
			this.renderTomorrowFuneral() :
			this.renderTodayFuneral();
	}

	renderResponse() {
		if (!this.state.response || this.state.static) {
			return;
		}
		const {success, message, time, status, extra} = this.state.response;
		const className = "response " + (success ? "success" : "error");
		const timeHtml = time ? (<span className="time"> {time}</span>) : null;

		let res = (
			<div className={className}>
				<span className="message">{message}</span>
				{timeHtml}
				{(status === 'uncertain' || status === 'impossible') ? (
					<span className="message">
						<br />
						<br />
                      <Trans> <b>Husk:</b> Du kan stadig nå at bestille blomster med levering næste dag (mandag-lørdag).</Trans>
					</span>
				) : null}

				{this.renderExtra()}
			</div>
		);

		return res;
	}

	renderInput() {
		if(this.state.funeral){
			return(
				<div className="input funeral-check">
                  <label htmlFor="delivery-time-checker-zipcode-input"><Trans>Indtast Postnr: </Trans></label>
					<input ref={input => this.input = input} type="text" id="delivery-time-checker-zipcode-input"
								 onKeyPress={this._handleKeyPress} pattern="\d*" placeholder={ translate("Indtast postnr.")} />
                  <button className="call-to-action btn funeral_today" onClick={this._handleTodayClickFuneral}><Trans>Levering i dag</Trans></button>
                  <button className="call-to-action btn funeral_tomorrow"
                          onClick={this._handleTomorrowClickFuneral}><Trans>Levering i morgen</Trans>
                  </button>
                  <span className="text-placeholder"/>
				</div>
			)
		} else {
			return(
				<div className="input">
                  <label htmlFor="delivery-time-checker-zipcode-input"><Trans>Indtast Postnr: </Trans></label>
					<input ref={input => this.input = input} type="text" id="delivery-time-checker-zipcode-input"
								 onKeyPress={this._handleKeyPress} pattern="\d*" placeholder={ translate("Indtast postnr.")} />
                  <button className="call-to-action btn" onClick={this._handleTodayClick}><Trans>Se levering</Trans></button>
                  <span className="text-placeholder"/>
				</div>
			)
		}
	}

	renderDeliveryText(){
		if(this.state.funeral){
			return (
              <Trans> <p>Tjek om din bestilling kan nå at blive leveret i dag/i morgen.</p> </Trans>
			)
		} else {
			return (
			 <Trans> <p> Tjek om din bestilling kan leveres i dag. </p> </Trans>
			)
		}
	}

	renderFooter() {
	    if (!this.props.group) {
          return <span className="text"><Trans>For levering af begravelsesblomster, <a className="funeral_check_front_page" href={env.get('checkout.special_group_paths.funeral', router.url('begravelse'))}>klik her</a></Trans></span>
		}

		const funeral = !this.state.funeral ?
              <span className="text"><Trans><a className="funeral_check_products_page" href={env.get('checkout.special_group_paths.funeral', router.url('begravelse'))}>Klik her</a> </Trans> <Trans>, for levering af begravelsesblomster </Trans></span> :
            null;

	    return (
	        <React.Fragment>
              <span className="text"><Trans>Vi leverer i hele landet. Vælg selv leveringsdato.</Trans></span>
				{funeral}
			</React.Fragment>
		);
	}

	render() {
		return (
			<div className={this.classNames} >
				<div className="delivery-time-checker">
					{this.renderDeliveryText()}
                    <span className="inline-text"><Trans>Vi leverer i hele landet. Vælg selv leveringsdato.</Trans></span>
					{this.renderInput()}
					<Modal ref={el => this.modal = el}>
						{this.renderStaticResponse()}
						{this.renderResponse()}
					</Modal>
				</div>
				{this.renderFooter()}
			</div>
		);
	}

}

module.exports = Widget;
